
<!-- image and product name -->
<div class="col-xl-5 col-lg-6 col-md-6 col-sm-5 col-5 product-info">
  <div class="row d-flex flex-row">
    <div class="d-md-block col-xl-3 col-lg-3 col-md-3 d-sm-none d-none">
      <div class="image" [ngStyle]="{'background-image': 'url(' + imageUrl + '), url(\'/assets/images/no-image-placeholder.png\')'}">
        <div class="content"></div>
        <a *ngIf="hasDetails" (click)="openDetails(line?.product)"></a>
      </div>
    </div>
    <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12 product-text cart-table-top-padding cart-table-bottom-padding">
      <span class="title">{{name}}</span>
      <!-- Display configured facets -->
      <div *ngIf="hasFacetsToDisplay">
        <div *ngFor="let facetWithValue of facetsWithValues" class="facets-with-values">
          <b>{{ facetWithValue.name }}</b> {{ facetWithValue.values }}
        </div>
      </div>
      <span class="productcode">{{ productDisplayCode }}</span>
      <!-- stock info -->
      <span class="stockmessage {{stockMessageClass}}" *ngIf="showDeliveryColumn">
        {{ stockMessage | translate:{ week: week } }}
      </span>
      <span class="backorder-warning" *ngIf="inBackorder">
        {{ 'checkout.backorderwarning' | translate }}
      </span>
      <span class="unit-info d-xl-none">
         {{ 'catalog.per-pieces' | translate: {count:  (stepping) } }}
      </span>
    </div>
  </div>
</div>

<!--
<div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 text-center cart-no-left-padding cart-table-top-padding">
    <button type="button" class="btn btn-link btn-remove" *ngIf="editable" (click)="removeLine()">
        <i class="fa fa-trash-o" aria-hidden="true"></i>
    </button>
</div>
-->

<!-- quantity and delete -->
<div class="col-xl-4 col-lg-4 col-md-4 col-sm-5 col-7 picker cart-table-top-padding text-left " *ngIf="editable">
  <app-quantity-picker-animated
    *ngIf="showQuantityPickerAnimated"
    [minQuantity]="minQuantity"
    [zeroAllowed]="false"
    [value]="calculatedQuantity"
    [stepping]="stepping"
    deferToBlur="true"
    [alignment]="'center'"
    [mode]="'checkout'"
    (quantityChanged)="onQuantityChanged($event)">
  </app-quantity-picker-animated>

  <app-quantity-picker
    *ngIf="!showQuantityPickerAnimated"
    [minQuantity]="minQuantity"
    [value]="calculatedQuantity"
    [stepping]="stepping"
    [mode]="'checkout'"
    [quantityType]="quantityPicker"
    (quantityChanged)="onQuantityChanged($event)">
  </app-quantity-picker>

   <!-- delete -->
   <a (click)="removeLine()" class="remove" [ngClass]="{ 'remove-relative': quantityPickerRelative }" *ngIf="editable">{{ 'orders.delete' | translate }}</a>

</div>

<div class="col-xl-4 col-lg-3 col-md-4 col-sm-5 col-7 text-left cart-table-top-padding" *ngIf="!editable && !quantityPickerRelative">
  {{ displayQuantity }}
</div>

<div class="col-xl-4 col-lg-3 col-md-4 col-sm-5 col-7 text-left cart-table-top-padding" *ngIf="!editable && quantityPickerRelative">
  <div class="row">
    <div class="col-xl-7 col-lg-12">{{ displayQuantity }}</div>
    <div class="d-none d-xl-block col-xl-3 text-center">{{ actualStepping }}</div>
    <div class="d-none d-xl-block col-xl-2 text-right">{{ absoluteQuantity }}</div>
  </div>
</div>

<!-- unit price -->
<div class="col-xl-1 d-xl-block d-lg-none d-md-none d-sm-none d-none unitprice money text-right cart-table-top-padding">
    <span *ngIf="showDiscount">
      <span class="price-stricken">{{ normalUnitPrice | price:currency }}</span> ({{discount}} %)
    </span>
    {{unitPrice | price:currency}}
</div>

<!-- <div class="td absolutequantity number">{{absoluteQuantity}}</div> -->

<!-- total price with discount -->
<div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 d-none d-sm-block subtotal money text-right cart-no-left-padding cart-table-top-padding">

  <!-- SK 16/10/2018 switched off because nikai told me to
  <span *ngIf="hasDiscount">
    <span class="price-stricken">{{ normalLinePrice | price:currency }}</span> ({{discount}} %)
  </span>
  -->

  {{linePrice | price:currency}}

</div>
